module.exports = __webpack_public_path__ + "img/article-card2.f3a9bca5.png";